<template>
    <div style=" background-color: #ffffff;">
        <div class="flexBox">
            <el-form class="demo-form-inline" :inline="true" ref="wmsWarehouseForm" :model="wmsWarehouseForm" size="mini" label-width="120px">
                <el-form-item label="任务类型" prop="taskType"> 
                    <el-select placeholder="请选择任务类型" v-model="wmsWarehouseForm.taskType">
                        <el-option v-for="item in taskTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账册编号" prop="handbook"> 
                    <el-select placeholder="请选择账册编号" v-model="wmsWarehouseForm.handbook" clearable>
                        <el-option v-for="item in handBookNoList" :key="item.bookNo" :label="item.bookNo" :value="item.bookNo"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务状态" prop="taskStatus"> 
                    <el-select placeholder="请选择任务类型" v-model="wmsWarehouseForm.taskStatus" clearable>
                        <el-option v-for="item in creationTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仓库名称" prop="ckName"> 
                    <el-select placeholder="请选择仓库" v-model="wmsWarehouseForm.ckName" clearable>
                        <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="委托单位" prop="customer"> 
                    <el-select placeholder="请选择委托单位" v-model="wmsWarehouseForm.customer" clearable>
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="货主" prop="ownerName"> 
                    <el-select placeholder="请选择货主" v-model="wmsWarehouseForm.ownerName" clearable>
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务单号" prop="billNo"> 
                    <el-input placeholder="请输入任务单号" clearable v-model="wmsWarehouseForm.billNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="提单号" prop="blNo"> 
                    <el-input placeholder="请输入提单号" clearable v-model="wmsWarehouseForm.blNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="保税类型" prop="isBonded"> 
                    <el-select placeholder="请选择保税类型" v-model="wmsWarehouseForm.isBonded" clearable>
                        <el-option v-for="item in bondedTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="报关单号" prop="cusDeclNo"> 
                    <el-input placeholder="请输入报关单号" clearable v-model="wmsWarehouseForm.cusDeclNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="核注清单号" prop="invDecNo"> 
                    <el-input placeholder="请输入核注清单号" clearable v-model="wmsWarehouseForm.invDecNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="创建日期" prop="createDate"> 
                    <el-date-picker v-model="wmsWarehouseForm.createDate" clearable value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="getCreateDate" > </el-date-picker>
                </el-form-item>
                <el-form-item label="计划作业日期" prop="planDate"> 
                    <el-date-picker v-model="wmsWarehouseForm.planDate" clearable value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="getPlanDate"> </el-date-picker>
                </el-form-item>
                <el-form-item > 
                    <el-button size="mini" @click="getTaskList" type="primary" plain>搜索</el-button>
                    <el-button size="mini" @click="clearSeacher"  plain>清空</el-button>
                    <el-button size="mini" @click="nweInWarehouse" plain>新增入库任务单</el-button>
                    <el-button size="mini" @click="nweoutbound" plain>新增出库任务单</el-button>
                </el-form-item>
            </el-form>
            <div >
                <vxe-toolbar ref="toolbarRef" custom> </vxe-toolbar>
            </div>
        </div>
        <div style="height: calc(100vh - 225px);">
            <vxe-table height="auto" :data="taskList" ref="wmsWarehouse" id="wmsWarehouse" size="mini" :columns="columns" :column-config="{ resizable: true }" 
            :custom-config="customConfig"  :row-config="{ isCurrent: true /* 启用当前行高亮 */ }" highlight-current-row  @cell-dblclick="getdetailsDblclick"
             :footer-method="footerMethod" show-footer> 
                <vxe-column type="seq" width="50" align="center"></vxe-column>
                <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title" sortable>
                    <template #default="{ row, column }">
                         <span v-if="column.field === 'billNo'" @click="getdetails(row)">
                            <el-link  type="primary">{{row.billNo}}</el-link>
                        </span>
                        <span v-if="column.field !== 'billNo'"> {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <!-- 171 -->
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize" :page-sizes="pageSizes"
            :total="pagination.total" @page-change="getTaskList" size="mini">
        </vxe-pager>
    </div>
</template>

<script>
import userProfile from '@/mixins/userProfile.js'
export default {
    name: 'inAndOutList',
    mixins: [userProfile],
    components:{
    },
    data() {
        return {
            openedWindows: {},
            jumpUrlId:'',
            taskList:[], // 入库任务单列表
            columns:[], // 列名
            // 分页信息
            pagination:{
                totalPages: 0, // 总页数
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 10, // 每页显示多少条数据
            },
            pageSizes:[10,15,20,50,100],
            wmsWarehouseForm:{
                ckName: '', // 仓库名称
                handbook: '', // 账册编号
                taskStatus: '', // 任务状态
                createDate:'', // 创建日期
                createDateStart: '', // 创建日期起
                createDateEnd: '', // 创建日期止
                taskType: '入库', // 出入库类型
                ownerName: '', // 货主单位
                billNo: '', // 任务单号
                blNo: '', // 提单号
                customer: '', // 委托单位
                isBonded: '', // 保税类型
                cusDeclNo: '', // 报关单号
                invDecNo: '', // 核注清单号
                planDate:'', // 计划作业日期
                planDateStart: '', // 计划作业日期起
                planDateEnd: '', // 计划作业日期止
            },
            taskTypeList:[
                {
                    value: '入库',
                    label: '入库'
                },{
                    value: '出库',
                    label: '出库'
                }
            ], // 任务类型
            creationTypeList:[
                {
                    value: '新建',
                    label: '新建'
                },{
                    value: '作业中',
                    label: '作业中'
                },{
                    value: '完成',
                    label: '完成'
                }
            ],// 任务状态
            handBookNoList:[], // 账册编号列表
            ckNameList:[],  // 仓库名称列表
            customerList:[], // 委托单位列表
            bondedTypeList:[], // 保税类型列表
        }
    },
    created() {
        this.getTaskList()
        this.gethandBookNo()
        this.getckNameList()
        this.getCompanyList()
        this.getIsBonded()
    },
    methods: {
        // 清空搜索条件
        clearSeacher(){
            this.$nextTick(()=>{
                this.$refs.wmsWarehouseForm.resetFields();
            })
        },
        // 获取账册编号列表
        gethandBookNo(){
            this.$api.wmsgetHandBook(  ).then(res =>{
                this.handBookNoList = res.tableData
            })
            
        },
        // 获取仓库
        getckNameList(){
            this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
            })
        },
        // 获取客户信息
        getCompanyList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 获取保税属性
        getIsBonded(){
            this.$api.getDicList( { value:'Wms保税属性'} ).then(res =>{
                this.bondedTypeList = res
            })
        },
        // 创建日期获取
        getCreateDate(data){
            if(data === null){
                this.wmsWarehouseForm.createDateStart = ''
                this.wmsWarehouseForm.createDateEnd = ''
            }else{
                this.wmsWarehouseForm.createDateStart = data[0]
                this.wmsWarehouseForm.createDateEnd = data[1]
            }
        },
        // 计划作业日期获取
        getPlanDate(data){
            if(data === null){
                this.wmsWarehouseForm.planDateStart = ''
                this.wmsWarehouseForm.planDateEnd = ''
            }else{
                this.wmsWarehouseForm.planDateStart = data[0]
                this.wmsWarehouseForm.planDateEnd = data[1]
            }
        },
        // 获取入库任务单列表
        getTaskList(){
            const { createDate,planDate, ...rest } = this.wmsWarehouseForm;
            const params = Object.keys(rest).reduce((acc, key) => {
                acc[key] = rest[key] === '' ? null : rest[key]; // 所有空字符串转 null
                return acc;
            }, {});            
            this.$api.getWMSTaskList( this.pagination.pageSize,this.pagination.currentPage,params ).then(res =>{
                this.taskList = res.tableData
                this.columns = res.columns
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })
        },
        // 新建入库任务单
        nweInWarehouse(){
            // this.jumpInWarehouse(localStorage.getItem('token'),localStorage.getItem('name'),'add')
            this.jumpInWarehouse(localStorage.getItem('token'),localStorage.getItem('name'),'add','in')
        },
        // 新建出库任务单
        nweoutbound(){
            this.jumpInWarehouse(localStorage.getItem('token'),localStorage.getItem('name'),'add','out')
        },
        jumpInWarehouse(tokens,names,ids,taskType){
            let url = '';
            if (taskType === 'in') {
                url = process.env.VUE_APP_BASE_HTML + '#/inWarehouse';
            } else if (taskType === 'out') {
                url = process.env.VUE_APP_BASE_HTML + '#/outbound';
            } else {
                console.error('未知的任务类型');
                return false;
            }
            const openedWindowsBoolean = localStorage.getItem('openedWindowsBoolean') ? JSON.parse(localStorage.getItem('openedWindowsBoolean').toLowerCase()) : true 
            // true是可以打开新窗口，false是已经有打开的新窗口
            // 如果是新建操作（id为add），新建和查看详情不管什么类型，一次都只能打开一个
            const windowKey = ids === 'add' ? `${taskType}_add` : `${taskType}_${ids}`;
            // 从本地存储中获取打开窗口信息
            // 检查窗口是否已打开
            if (!openedWindowsBoolean) { // 有窗口打开
                this.$message.error('已有打开窗口');
                return false;
            }
            // 生成唯一的窗口标识
            const uniqueWindowKey = `PopupWindow_${windowKey}_${Date.now()}`;
            const timestamp = Date.now();
            const uniqueUrl = `${url}?timestamp=${timestamp}&id=${ids}&type=${taskType}`;
            const popup = window.open(
                uniqueUrl,
                uniqueWindowKey,
                'width=1860,height=870,top=60,resizable=yes,scrollbars=yes'
            );
            if (!popup) {
                this.$message.error('弹窗被阻止！');
                return false;
            }
            // 记录打开的窗口信息
            this.openedWindows = {
                popup: popup,
                key: uniqueWindowKey,
                taskType: taskType,
                taskId: ids === 'add' ? null : ids,
                isAdd: ids === 'add',
                lastActive: Date.now()
            }
            localStorage.setItem('openedWindowsBoolean', false);

            // 窗口关闭检测定时器（始终运行，直到窗口关闭）
            const windowCloseChecker = setInterval(() => {
                if (popup.closed) {
                    clearInterval(windowCloseChecker);
                    clearInterval(messageSender); // 也清除消息发送器
                    
                    // 清理本地存储和状态
                    localStorage.setItem('openedWindowsBoolean', true);
                    this.openedWindows = {};
                    
                    // 刷新父页面列表
                    this.getTaskList();
                    return;
                }
            }, 500);
            let tokenReceived = false; // 标记是否收到确认信息
            // 消息发送定时器（只在未收到确认时发送）
            const messageSender = setInterval(() => {
                if(!tokenReceived){
                    try {
                        popup.postMessage(
                            { 
                                type: 'SET_TOKEN', 
                                token: tokens,
                                name: names,
                                id: ids === 'add' ? '' : ids,
                            },
                            process.env.VUE_APP_BASE_HTML
                        );
                    } catch (e) {
                        // 忽略跨域错误
                    }
                }else{
                    // 收到确认后停止发送
                    clearInterval(messageSender);
                }
                
            }, 500);
            // 监听子窗口的确认消息
            const messageHandler = (event) => {
                if (event.data.type === 'TOKEN_RECEIVED') {
                    tokenReceived = true; // 标记已收到确认
                    clearInterval(messageSender);  // 收到确认后停止发送
                    window.removeEventListener('message', messageHandler);  // 移除事件监听
                }
            };
            window.addEventListener('message', messageHandler);
            return true;
        },
        // 跳转入库详情/新建页面
        // jumpInWarehouse(tokens,names,ids){
        //     const url = process.env.VUE_APP_BASE_HTML + '#/inWarehouse'
        //     // 判断id是否被打开
        //     if(this.jumpUrlId === ids){
        //         this.$message.error('任务已被打开');
        //         return false
        //     }
        //     this.jumpUrlId = ids
        //     const popup = window.open(
        //         url,
        //         'PopupWindow' + this.jumpUrlId,
        //         'width=1860,height=870,top=60'
        //     );
        //     if (!popup) {
        //         this.$message.error('弹窗被阻止！');
        //     }
        //     // 添加子窗口关闭检测
        //     const checkPopupClosed = setInterval(() => {
        //         if (popup.closed) {
        //             clearInterval(checkPopupClosed);
        //             this.jumpUrlId = '';  // 子窗口关闭后重置 jumpUrlId
        //             return;
        //         }
        //     }, 500);

        //     // 等待子窗口加载完成后发送 Token
        //     const timer = setInterval(() => {
        //         if (popup.closed) {
        //             clearInterval(timer);
        //             clearInterval(checkPopupClosed);
        //             this.jumpUrlId = null;
        //             return;
        //         }
        //         popup.postMessage(
        //             { type: 'SET_TOKEN', token:tokens,name:names,id:ids === 'add' ? '' : ids  },
        //             url // 限制目标域名
        //         );
        //     }, 1000);
        //     // 监听子窗口的确认消息
        //     const messageHandler = (event) => {
        //         if (event.data.type === 'TOKEN_RECEIVED') {
        //             clearInterval(timer); // 收到确认后停止发送
        //             window.removeEventListener('message', messageHandler); // 移除事件监听
        //         }
        //     };
        //     window.addEventListener('message', messageHandler);
        // },
        //查看任务详情
        getdetails(row){
            if(row.taskType === '出库'){
                this.jumpInWarehouse(localStorage.getItem('token'),localStorage.getItem('name'),row.id,'out')
            }else{
                this.jumpInWarehouse(localStorage.getItem('token'),localStorage.getItem('name'),row.id,'in')
            }
        },
        // 双击列查看详情
        getdetailsDblclick({ row, column }){
            this.jumpInWarehouse(localStorage.getItem('token'),localStorage.getItem('name'),row.id)
        },
        // 合计表格表尾
        footerMethod({ columns, data }) {
            // 定义需要显示合计的字段
            const sumFields = ['qty1Sum','netWeight'];
            
            // 计算合计值
            const sums = {};
            sumFields.forEach(field => {
                sums[field] = data.reduce((acc, row) => {
                return acc + (Number(row[field]) || 0);
                }, 0);
            });
      
            return [
                columns.map((column, columnIndex) => {
                    const { field } = column;
                
                    // 第一列显示"合计"
                    if (columnIndex === 0) {
                        return '合计';
                    }
                
                    // 如果字段需要合计，显示合计值
                    if (sumFields.includes(field)) {
                        return this.formatNumber({ cellValue: sums[field] });
                    }
                
                    // 其他列显示"-"
                    return '-';
                })
            ];
        },
        formatNumber({ cellValue }) {
            // 1. 处理空值
            if (cellValue == null || cellValue === '') return '';
             // 2. 尝试转换为数字
            const num = Number(cellValue);
            // 3. 检查转换是否成功
            if (isNaN(num)) return cellValue;
            // 4. 使用国际化 API 格式化数字
            return num.toLocaleString('en-US', {
                minimumFractionDigits: 2, // 最少保留2位小数
                maximumFractionDigits: 2// 最多保留2位小数
            });
        },
    }
}
</script>
<style style lang="less" scoped>
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
.flexBox{
    display: flex;
    align-items: flex-end;
}
// 任务单号样式
.el-link{
    font-size: 12px;
}
</style>